import React from 'react';
import {
  UButton,
  UText,
  UNovel,
  UImage,
  UBannerButton,
} from '@tencent/smp-ui';
import { reportUrl, initPageCollect } from '@tencent/smp-tools';
import DefaultSmp from './defaultSmpData';
import './index.scss';

class Index extends React.Component {
  constructor() {
    super();
    this.state = {
      subkey: '',
      hasProgress: false,
      channelVisible: false,
    };
    this.btnRef = React.createRef();
    this.footerBtnRef = React.createRef();
    this.channelBtnRef = React.createRef();
  }

  handleReport({ action = '', subkey = '' }) {
    const { stat = '' } = window.RENDER_DATA || {};
    reportUrl
      && reportUrl({
        statUrl: stat,
        action,
        subkey,
      });
  }

  componentDidMount() {
    const { stat = '', channel } = window.RENDER_DATA || DefaultSmp;
    initPageCollect({
      statUrl: stat,
    });

    window.onscroll = () => {
      if (channel) {
        let channelVisible = false;
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        const { offsetTop } = document.getElementById('readAllText') || {};
        if ((offsetTop + 40) >= scrollTop) {
          channelVisible = false;
        } else {
          channelVisible = true;
        }
        this.setState({
          channelVisible,
        });
      }
    };
  }

  // 文末图片点击
  handleFooterImageClick() {
    this.handleReport({ action: 'CLICK', subkey: 'footergif' });
    this.btnRef.current.handleClick();
  }

  handleLoadingImageClick() {
    this.handleReport({ action: 'CLICK', subkey: 'loading' });
    this.btnRef.current.handleClick();
  }

  // 创意图片点击
  handleImageClick() {
    this.handleReport({ action: 'CLICK', subkey: 'image' });
    this.btnRef.current.handleClick();
  }

  handleBtnReady(refName) {
    // 判断是否需要展示顶部应用信息
    const { appStatus } = this[refName]?.current?.getAppStatus();
    this.setState({ appStatus });
  }

  handleAppDownloadProgress(refName) {
    const appInfo = this[refName]?.current?.getAppStatus();
    console.log('handleAppDownloadProgress', refName, appInfo?.progress);
    this.setState({
      hasProgress: appInfo?.progress > 0
    });
  }

  render() {
    return (
      <div className="main-panel">
        {this.renderBg()}
        {this.renderTitle()}
        {this.renderBanner()}
        {this.renderChannel()}
        {this.renderDesc()}
        {this.renderNovel()}
        {this.renderFooter()}
        {this.renderBtn()}
      </div >
    );
  }

  renderBg() {
    const { bg } = window.RENDER_DATA || DefaultSmp;
    return bg ? <UImage ui={bg} className="bg" /> : null;
  }

  renderTitle() {
    const { title } = window.RENDER_DATA || DefaultSmp;
    return title ? <UText ui={title} /> : null;
  }
  renderDesc() {
    const { desc } = window.RENDER_DATA || DefaultSmp;
    return desc ? <UText ui={desc} className="desc" /> : null;
  }

  renderBanner() {
    const { banner } = window.RENDER_DATA || DefaultSmp;
    if (banner) {
      return (
        <UImage ui={banner} className="banner" onClick={() => this.handleImageClick()} />
      )
    }
    return null;
  }

  renderChannel() {
    const { channelVisible } = this.state;
    const { channel, app, stat } = window.RENDER_DATA || DefaultSmp;
    const formatApp = {
      ...app,
      auto: false,
      autoActive: false,
      fileIcon: 'http://pp.myapp.com/ma_icon/0/icon_11384_1587715513/256',
      autoOpen: false,
      canpause: true,
    };
    return (
      <React.Fragment>
        {channel
          ? <p className='read-all-text' id='readAllText'>
            < img width="100%" height="50" src='https://smpimg-1258344701.file.myqcloud.com/smpreal/SMP_20201202_1182279.gif' />
          </p >
          : null
        }
        {
          channel && channelVisible
            ? <div className='channel-box-fixed'>
              <UBannerButton
                ref={this.channelBtnRef}
                ui={channel}
                app={formatApp}
                stat={stat}
                subkey='bannerbtn'
                onAppDownloadProgress={() => this.handleAppDownloadProgress('channelBtnRef')}
              /></div>
            : null
        }
      </React.Fragment>
    )
  }

  renderNovel() {
    const { novel, novelbtn, app, stat } = window.RENDER_DATA || DefaultSmp;
    const formatApp = {
      ...app,
      auto: false,
      autoActive: false,
      fileIcon: 'http://pp.myapp.com/ma_icon/0/icon_11384_1587715513/256',
      autoOpen: false,
      canpause: true,
    };
    if (novel) {
      return <UNovel ui={novel} >
        {novelbtn
          ? <UButton
            ui={novelbtn}
            app={formatApp}
            stat={stat}
            subkey='novelbtn' />
          : null
        }
      </UNovel>
    }
    return null;
  }

  renderFooter() {
    const {
      stat = '',
      footerGif,
      footerBtn,
    } = window.RENDER_DATA || DefaultSmp;
    const { app } = window.RENDER_DATA || DefaultSmp;
    const formatApp = {
      ...app,
      auto: false,
      autoActive: false,
      fileIcon: 'http://pp.myapp.com/ma_icon/0/icon_11384_1587715513/256',
      autoOpen: false,
      canpause: true,
    };
    return (
      <div className="footer">
        {footerGif
          ? (
            <UImage ui={footerGif}
              onClick={() => this.handleFooterImageClick()}
            />
          )
          : null}

        {footerBtn
          ? <UButton
            ref={this.footerBtnRef}
            ui={footerBtn}
            app={formatApp}
            stat={stat}
            subkey='footerbtn'
            onBtnReady={() => this.handleBtnReady('footerBtnRef')}
            onAppDownloadProgress={() => this.handleAppDownloadProgress('footerBtnRef')}
          />
          : null}
      </div>
    )
  }

  renderBtn() {
    const { hasProgress } = this.state;
    const {
      btn,
      stat = '',
      loadingimg,
    } = window.RENDER_DATA || DefaultSmp;
    const { app } = window.RENDER_DATA || DefaultSmp;
    const formatApp = {
      ...app,
      auto: false,
      autoActive: false,
      fileIcon: 'http://pp.myapp.com/ma_icon/0/icon_11384_1587715513/256',
      autoOpen: false,
      canpause: true,
    };

    if (btn) {
      return (
        <div className="fixed-footer">
          {loadingimg && hasProgress
            ? < UImage
              ui={loadingimg}
              style={{ position: 'relative' }}
              onClick={() => this.handleLoadingImageClick()}
              className="loading"
            />
            : null
          }
          <UButton
            ref={this.btnRef}
            ui={{
              ...btn,
              style: {
                ...btn.style,
                outer: {
                  ...btn.style.outer,
                  position: 'relative'
                }
              }
            }}
            app={formatApp}
            stat={stat}
            subkey='downloadbtn'
            onBtnReady={() => this.handleBtnReady('btnRef')}
            onAppDownloadProgress={() => this.handleAppDownloadProgress('btnRef')}
          />
          {this.renderAppInfo()}
        </div>
      )
    }
    return <div className="fixed-footer">{this.renderAppInfo()}</div>
  }

  getAppLinkInfo(packagename) {
    if (packagename === 'sogou.mobile.explorer') {
      return {
        appname: '搜狗浏览器极速版',
        qbversion: '12.0.0.1018',
        qbupdatetime: '2021/12/06',
        developer: '北京搜狗科技发展有限公司',
        access: 'http://rule.tencent.com/rule/preview/fd7014e2-5e1b-47c8-8998-ce439cd90d05',
        privacy: 'https://rule.tencent.com/rule/preview/ace4720a-c474-47cb-9800-1e83fff6a382',
      };
    }

    if (packagename === 'com.sogou.reader.free') {
      return {
        appname: '搜狗免费小说极速版',
        qbversion: '12.0.0.1014',
        qbupdatetime: '2021/12/06',
        developer: '北京搜狗科技发展有限公司',
        access: 'https://docs.qq.com/doc/p/1a5d01edb2b2023b54abd2ef34370726b4c6766b?dver=2.1.27266726',
        privacy: 'https://static.res.qq.com/nav/sogoureader/sogoureader_privacy.html',
      };
    }

    // 默认走‘QQ浏览器'
    return {
      appname: 'QQ浏览器',
      qbversion: window.qbversion || '13.7.0.0037',
      qbupdatetime: window.qbupdatetime || '2023/03/08',
      developer: '腾讯科技（深圳）有限公司',
      access: 'https://upage.imtt.qq.com/app-info/qb.html',
      privacy: 'https://static.res.qq.com/nav/qb_privacy.html',
    }
  }

  renderAppInfo() {
    const { appStatus } = this.state;
    const { app = {} } = window.RENDER_DATA || {};

    if (appStatus === 6) {
      return null;
    }

    const {
      appname,
      qbversion,
      qbupdatetime,
      developer,
      access,
      privacy
    } = this.getAppLinkInfo(app.packagename);

    return (
      <div style={{ fontSize: 10, margin: 0, padding: 6, textAlign: 'center', width: '100%', background: '#fff', bottom: 0, zIndex: 10000 }}>
        <p style={{ margin: 0, padding: 2 }}>
          <span style={{ paddingRight: 4 }}>应用名称：{appname} 版本：{qbversion}</span>
          <span>更新时间：{qbupdatetime}</span>
        </p>
        <p style={{ margin: 0, padding: 2 }}>
          开发者：{developer} &nbsp;
          <a style={{ color: 'gray', textDecoration: 'underline' }} href={access}>权限信息</a> &nbsp;
          <a style={{ color: 'gray', textDecoration: 'underline' }} href={privacy}>隐私协议</a>
        </p>
      </div>
    );
  }
}
export default Index;
